import { inject, Injectable } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';

@Injectable({
	providedIn: 'root',
})
export class TranslatorUtil {
	private translocoService = inject(TranslocoService);

	public translateAndSort(arrayToTranslate: any[], translatePrefix: string) {
		return arrayToTranslate
			.map((value) => ({
				value,
				label: this.translocoService.translate(translatePrefix + value),
			}))
			.sort((a, b) => a.label.localeCompare(b.label));
	}
}
